import React from 'react';
import MaxWidth from '../components/MaxWidth';
import SectionLabel from '../components/SectionLabel';
import IconBoxQ14 from '../assets/icons/IconBoxQ14';
import Spacer from '../components/Spacer';
function SectionRDV() {
  return (
    <div style={{ padding: "var(--fp-size-section-padding-v2) 0", backgroundColor: "var(--fp-color-white)", position: "relative" }}>
      <MaxWidth>
        <div style={{position: "relative", zIndex: "1"}}>
          <SectionLabel
            icon={<IconBoxQ14 fill={"var(--fp-comp-section-label-icon-fill)"} stroke={"var(--fp-color-blue-main)"} />}
            title={"Prendre un rendez-vous"}
            isWhite={true}
          />
          <Spacer size={"16px"} />
          <h2 className='fp-text-style-header-large'>
            Nos experts à votre disposition
            <br />
            Prenez rendez-vous en toute simplicité !
          </h2>
          <Spacer size={"48px"} />

          <iframe
            src="https://meetings-eu1.hubspot.com/antoine-chrifi?embed=true"
            style={{ width: '100%', minHeight: '700px', border: 'none' }}
            title="Prendre un rendez-vous"
          />
        </div>
      </MaxWidth>
    </div>
  );
}
export default SectionRDV;